/**
 * @example
 * const cls = createClassWithModifiers("class",
 *   { "foo": true,
 *     "bar": false,
 *     "object": {}
 *   },
 *   ["array"]
 * );
 * cls === "class class--foo class--object class--array"
 */
export function createClassWithModifiers(
  baseClass: string,
  ...modifierArgs: (Record<string, any> | string[])[]
): string {
  let result: string[] = [baseClass];

  modifierArgs.forEach((modifiers) => {
    if (modifiers instanceof Array) {
      modifiers.forEach((m) => m && result.push(`${baseClass}--${m}`));
    } else {
      Object.entries(modifiers).forEach((entry) => result.push(entry[1] ? baseClass + "--" + entry[0] : ""));
    }
  });

  return result.filter((_) => _).join(" ");
}
